import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { ScreenType } from 'projects/common/model/ScreenType';

export type RankingNumberVariant = 'default' | 'full-rounded';

@Component({
  selector: 'ranking-number',
  template: `
    <div class="ranking-number" 
        [ngClass]="['-' + variant, '-' + screenType.toLowerCase()]"
        
        >
      <span>{{ position }}</span>
    </div>
  `,
  styleUrls: ['./ranking-number.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RankingNumberComponent implements OnInit {
  @Input() position: number;
  @Input() variant: RankingNumberVariant = 'default';

  screenType: ScreenType;

  constructor(private landingModelService: LandingModelService) {}

  ngOnInit(): void {
    this.screenType = this.landingModelService.getLandingModel().device.type;
  }
}
